"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxLabelWrapper = exports.StyledCheckbox = exports.HiddenCheckbox = exports.SquareStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Subtitle_1 = require("../Typography/Subtitle");
const Color_enum_1 = require("../../constants/Color.enum");
exports.SquareStyled = styled_components_1.default.div `
    width: 8px;
    height: 8px;
    background-color: ${Color_enum_1.Color.Primary};
    visibility: hidden;
`;
exports.HiddenCheckbox = styled_components_1.default.input.attrs({ type: 'checkbox' }) `
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;

    &:checked + * ${exports.SquareStyled} {
        visibility: visible;
    }
`;
exports.StyledCheckbox = styled_components_1.default.div `
    margin-right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${Color_enum_1.Color.Variant_1};
    width: 18px;
    height: 18px;
    background-color: ${Color_enum_1.Color.Surface};
    border-radius: 3px;
    transition: all 150ms;

    ${exports.HiddenCheckbox}:hover + &, ${exports.HiddenCheckbox}:focus + & {
        border-color: ${Color_enum_1.Color.Secondary};
    }
`;
exports.CheckboxLabelWrapper = styled_components_1.default.label `
    ${(0, Subtitle_1.getSubtitleExtraSmallStyles)()};

    display: inline-flex;
    position: relative;
    align-items: center;
    cursor: pointer;

    &:hover,
    &:focus {
        color: ${Color_enum_1.Color.Secondary};
    }
`;
